import clsx from 'clsx'
import { Loader } from '@/components/Loader'
import { ButtonBase } from '../ButtonBase'
import { TSizeAll } from 'src/types'
import { IVariantButtonProps } from '../types'
import styles from './styles.module.scss'

const ButtonLink = ({
  children,
  className,
  isLoading,
  variant = 'default',
  ...props
}: IVariantButtonProps) => {
  const adjustSize = (size?: TSizeAll) => {
    switch (size) {
      case 'xl':
        return styles.linkXL
      case 'lg':
        return styles.linkLG
      case 'sm':
        return styles.linkSM
      case 'xs':
        return styles.linkXS
      default:
        return styles.linkMD
    }
  }

  return (
    <ButtonBase
      data-testid="mui-button-link"
      className={clsx(styles.link, styles[variant], className, adjustSize(props.size))}
      isLoading={isLoading}
      {...props}
    >
      {isLoading && <Loader className={clsx(styles.loader, styles[variant])} />}
      {children}
    </ButtonBase>
  )
}

export default ButtonLink
